import MarketplaceTag from "features/newMarketplace/common/MarketplaceTag";
import React, { CSSProperties } from "react";
import styled from "styled-components";
import { MarketplaceSubGroup } from "@shared/types";
import { SUB_GROUP_CARD_TAGS } from "@shared/features/newMarketplace/constants";

interface GroupTagsProps {
  group: MarketplaceSubGroup;
  style?: CSSProperties;
}

const GroupTags = ({ group, style }: GroupTagsProps) => {
  return (
    <TagsWrapper>
      {SUB_GROUP_CARD_TAGS.map((tagName) => (
        <MarketplaceTag
          key={tagName}
          tagName={tagName}
          group={group}
          style={style}
        />
      ))}
    </TagsWrapper>
  );
};

export default GroupTags;

const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 4px;
`;
